import { z } from 'zod/v4';

/**
 * The indent widget's structured **styles** group — the data carried by the
 * envelope's `styles` and `mobileStyles` fields. Both hold the same single
 * measurement, in px; the mobile one applies below 992px and, in the editor,
 * under the mobile device preview.
 *
 * The third widget (after image and line) whose `styles` is typed rather than
 * the open JSS `styleBagSchema` record — and the first whose `mobileStyles` is
 * typed too.
 */
export const INDENT_HEIGHT_BOUNDS = { min: 0 } as const;

export const indentStylesSchemaLegacy = z.object({
    height: z.number().meta(INDENT_HEIGHT_BOUNDS),
});

export type IndentStylesLegacy = z.infer<typeof indentStylesSchemaLegacy>;

/** Default spacer height — the source of the host `indent.model.ts` defaults. */
export const createIndentStylesLegacy = (overrides: Partial<IndentStylesLegacy> = {}): IndentStylesLegacy => ({
    height: 40,
    ...overrides,
});
